import { FocusEvent, forwardRef, KeyboardEvent, MouseEvent } from 'react';
import { FONT_COLOURS } from '@belong/themes';
import { ICON_NAMES } from '@belong/types';
import * as styles from './styles';

export interface IHeaderBarLink {
  'aria-current'?: any;
  'aria-label'?: string;
  'aria-selected'?: any;
  'data-testid'?: string;
  asUrl?: string;
  hideUnderline?: boolean;
  href?: string;
  iconName?: ICON_NAMES;
  iconRight?: boolean;
  rotateIconOnHover?: boolean;
  label?: string;
  isRightLink?: boolean;
  onClick?: (e: MouseEvent<any>) => void;
  onMouseEnter?: (e: MouseEvent<any>) => void;
  onBlur?: (e: FocusEvent<any>) => void;
  onFocus?: (e: FocusEvent<any>) => void;
  onKeyDown?: (e: KeyboardEvent<any>) => void;
  id?: string;
}

export const HeaderBarButton = forwardRef(
  (
    { iconName, iconRight, label, href, rotateIconOnHover, isRightLink, onKeyDown, ...props }: IHeaderBarLink,
    ref: any
  ) => {
    const hasColor =
      props['aria-current'] || props['aria-selected'] || props['aria-expanded']
        ? FONT_COLOURS.ACTIVE
        : FONT_COLOURS.LIGHT;

    // the withLink HOC doesn't support refs, so there are two versions of
    // the wrapper component, so that when the HeaderBarLink functions as
    // a button, the ref will work.
    if (!href) {
      return (
        <styles.Wrapper ref={ref} {...props} onKeyDown={onKeyDown} isRightLink={isRightLink}>
          <styles.ButtonText hasColor={hasColor} as="span">
            {iconRight ? (
              <>
                {label}
                {iconName && (
                  <styles.StyledIcon
                    name={iconName}
                    hasColor={hasColor}
                    hasPadding={!!label}
                    iconRight
                    rotateIconOnHover
                  />
                )}
              </>
            ) : (
              <>
                {iconName && <styles.StyledIcon name={iconName} hasColor={hasColor} hasPadding={!!label} />}
                {label}
              </>
            )}
          </styles.ButtonText>
        </styles.Wrapper>
      );
    }

    return (
      <styles.WrapperWithLink href={href} {...props}>
        <styles.LinkText hasColor={hasColor}>
          {iconRight ? (
            <>
              {label}
              {iconName && (
                <styles.StyledIcon
                  name={iconName}
                  hasColor={hasColor}
                  hasPadding={!!label}
                  iconRight
                  rotateIconOnHover
                />
              )}
            </>
          ) : (
            <>
              {iconName && <styles.StyledIcon name={iconName} hasColor={hasColor} hasPadding={!!label} />}
              {label}
            </>
          )}
        </styles.LinkText>
      </styles.WrapperWithLink>
    );
  }
);

HeaderBarButton.displayName = 'HeaderBarButton';

export default HeaderBarButton;
